const ElTableColumn = ELEMENT.TableColumn;

export const DsfElTableColumn = {
  name: 'DsfElTableColumn',
  mixins: [ElTableColumn],
  methods: {
    setColumnForcedProps(column) {
      // 对于特定类型的 column，某些属性不允许设置
      const type = column.type;
      if (type != 'selection') {
        return ElTableColumn.methods.setColumnForcedProps.call(this, column);
      }
      const source = cellForced[type] || {};
      Object.keys(source).forEach(prop => {
        let value = source[prop];
        if (value !== undefined) {
          column[prop] = prop === 'class' ? `${column[prop]} ${value}` : value;
        }
      });
      return column;
    }
  }
};

const cellForced = {
  selection: {
    renderHeader: function (h, {store}) {
      return checkbox(h, {
        indeterminate: store.states.selection.length > 0 && !this.isAllSelected,
        disabled: store.states.data && store.states.data.length === 0,
        value: this.isAllSelected
      }, {
        click: e => this.toggleAllSelection(e)
      });
    },
    renderCell: function (h, {row, column, store, $index}) {
      return checkbox(h, {
        disabled: column.selectable ? !column.selectable.call(null, row, $index) : false,
        value: store.isSelected(row)
      }, {
        click: e => {
          e.stopPropagation();
          store.commit('rowSelectedChanged', row);
        },
      });
    },
    sortable: false,
    resizable: false
  }
};

export const checkbox = function (h, {indeterminate = false, disabled = false, value = false}, {click}, child = []) {
  const classList1 = ['el-checkbox'];
  const classList2 = ['el-checkbox__input'];
  const listeners = {};
  if (indeterminate) {
    classList2.push('is-indeterminate');
  }
  if (value) {
    classList2.push('is-checked');
    classList2.push('is-checked');
  }
  if (disabled) {
    classList2.push('is-disabled');
    classList2.push('is-disabled');
  } else {
    listeners.click = click;
  }
  if (child && !dsf.isArray(child)) {
    child = [child];
  }
  if (child.length) {
    child = (<span class="el-checkbox__label">{child}</span>);
  }
  return (<label class={classList1} on={listeners}>
    <span class={classList2}>
      <span class="el-checkbox__inner"></span>
    </span>
    {child}
  </label>);
};
